var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "csa" },
    [
      !_vm.dataloaded
        ? _c("eas-loader")
        : _c("div", { staticClass: "csabody" }, [
            _c("div", { staticClass: "flex-row flex-5 mb-1" }, [
              _c("div", { staticClass: "flex-col flex-4" }, [
                _c("div", { staticClass: "flex-row flex-1" }, [
                  _c(
                    "div",
                    {
                      staticClass: "flex-col flex-1 flex-justify-center label",
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.csaLabels.commercialOutlookLabel) + ": "
                      ),
                    ]
                  ),
                  _c("div", { staticClass: "flex-col flex-1" }, [
                    _c("div", { staticClass: "flex-row flex-1" }, [
                      _c(
                        "div",
                        { staticClass: "flex-col flex-1 flex-justify-center" },
                        [
                          _vm._v(
                            _vm._s(_vm.csaLabels.commercialOutlookSubLabel1) +
                              ": "
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "flex-col flex-1 flex-justify-center" },
                        [_vm._v(_vm._s(_vm.csaData.commercialOutlookSubValue1))]
                      ),
                    ]),
                    _c("div", { staticClass: "flex-row flex-1" }, [
                      _c(
                        "div",
                        { staticClass: "flex-col flex-1 flex-justify-center" },
                        [
                          _vm._v(
                            _vm._s(_vm.csaLabels.commercialOutlookSubLabel2) +
                              ": "
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "flex-col flex-1 flex-justify-center" },
                        [_vm._v(_vm._s(_vm.csaData.commercialOutlookSubValue2))]
                      ),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "flex-row flex-2" }, [
                  _c(
                    "div",
                    {
                      staticClass: "flex-col flex-1 flex-justify-center label",
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.csaLabels.currentValueDriverLabel) + ": "
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex-col flex-1 flex-justify-center pre-formatted",
                    },
                    [_vm._v(_vm._s(_vm.csaData.currentValueDriver))]
                  ),
                ]),
                _c("div", { staticClass: "flex-row flex-2" }, [
                  _c(
                    "div",
                    {
                      staticClass: "flex-col flex-1 flex-justify-center label",
                    },
                    [_vm._v(_vm._s(_vm.csaLabels.ltContractValueLabel) + ": ")]
                  ),
                  _c(
                    "div",
                    { staticClass: "flex-col flex-1 flex-justify-center" },
                    [_vm._v(_vm._s(_vm.csaData.ltContractValue))]
                  ),
                ]),
                _c("div", { staticClass: "flex-row flex-2" }, [
                  _c(
                    "div",
                    {
                      staticClass: "flex-col flex-3 flex-justify-center label",
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.csaLabels.runningRegimeTrendLabel) + ": "
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "flex-col flex-2 flex-justify-center" },
                    [_vm._v(_vm._s(_vm.csaData.runningRegime))]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "flex-col flex-1 flex-justify-center",
                      staticStyle: { "align-items": "center" },
                    },
                    [
                      _vm.csaData.runningTrend == "Unchanged"
                        ? _c(
                            "div",
                            { staticStyle: { "font-size": "2rem" } },
                            [
                              _c("font-awesome-icon", {
                                attrs: { icon: ["fas", "arrow-right"] },
                              }),
                            ],
                            1
                          )
                        : _vm.csaData.runningTrend == "Up"
                        ? _c(
                            "div",
                            {
                              staticClass: "uparrow",
                              staticStyle: { "font-size": "2rem" },
                            },
                            [
                              _c("font-awesome-icon", {
                                attrs: { icon: ["fas", "arrow-up"] },
                              }),
                            ],
                            1
                          )
                        : _vm.csaData.runningTrend == "Down"
                        ? _c(
                            "div",
                            {
                              staticClass: "downarrow",
                              staticStyle: { "font-size": "2rem" },
                            },
                            [
                              _c("font-awesome-icon", {
                                attrs: { icon: ["fas", "arrow-down"] },
                              }),
                            ],
                            1
                          )
                        : _vm.csaData.runningTrend == "No running forecasted"
                        ? _c("div", [
                            _vm._v(_vm._s(_vm.$t("noRunningForecasted"))),
                          ])
                        : _vm._e(),
                    ]
                  ),
                ]),
              ]),
              _c("div", { staticClass: "flex-col flex-3" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "flex-row flex-1 flex-justify-center chart-title chart-title-fcf",
                  },
                  [_vm._v(_vm._s(_vm.$t("freeCashFlow")))]
                ),
                _c("div", { staticClass: "flex-row flex-6 flex-justify-end" }, [
                  _c("div", {
                    staticClass: "fcf-chart",
                    attrs: { id: _vm.fcfChartId },
                  }),
                ]),
                _c(
                  "div",
                  { staticClass: "flex-row flex-1 flex-justify-center mb-2" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "flex-col flex-align-end text-no-wrap pl-5",
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "legend-p5-p95" },
                          [
                            _c("font-awesome-icon", {
                              attrs: { icon: ["fas", "square"] },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c("div", { staticClass: "flex-col" }, [
                      _vm._v("P5 - P95"),
                    ]),
                  ]
                ),
                _vm.csaData.isCo2GraphRequired
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "flex-row flex-1 flex-justify-center chart-title chart-title-co2",
                      },
                      [_vm._v(_vm._s(_vm.$t("absoluteCo2Emissions")))]
                    )
                  : _vm._e(),
                _vm.csaData.isCo2GraphRequired
                  ? _c(
                      "div",
                      { staticClass: "flex-row flex-6 flex-justify-end" },
                      [
                        _c("div", {
                          staticClass: "co2-chart",
                          attrs: { id: _vm.co2ChartId },
                        }),
                      ]
                    )
                  : _c("div", { staticClass: "co2graphspace" }),
              ]),
            ]),
            _c("div", { staticClass: "flex-row flex-2 mb-1" }, [
              _c(
                "div",
                { staticClass: "flex-col flex-4 flex-justify-center label" },
                [
                  _c("p", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.csaLabels.co2AbatementCostsLabel.replace(
                          "CO2",
                          "CO<sub>2</sub>"
                        ) + ":"
                      ),
                    },
                  }),
                ]
              ),
              _c("div", { staticClass: "flex-col flex-3" }, [
                _c("div", { staticClass: "flex-row flex-1" }, [
                  _vm._v(_vm._s(_vm.csaData.co2AbatementCostsText1)),
                ]),
                _c("div", { staticClass: "flex-row flex-1" }, [
                  _vm._v(_vm._s(_vm.csaData.co2AbatementCostsText2)),
                ]),
              ]),
              _c("div", { staticClass: "flex-col flex-3" }, [
                _c("div", { staticClass: "flex-row flex-1" }, [
                  _vm._v(_vm._s(_vm.csaData.co2AbatementCostsValue1)),
                ]),
                _c("div", { staticClass: "flex-row flex-1" }, [
                  _vm._v(_vm._s(_vm.csaData.co2AbatementCostsValue2)),
                ]),
              ]),
              _c("div", { staticClass: "flex-col flex-3" }, [
                _c("div", { staticClass: "flex-row flex-1" }, [
                  _vm._v(_vm._s(_vm.csaLabels.specificEmissionsLabel) + ": "),
                ]),
                _c("div", { staticClass: "flex-row flex-1" }, [
                  _vm._v(_vm._s(_vm.csaData.specificEmissionsText)),
                ]),
              ]),
              _c("div", { staticClass: "flex-col flex-3" }, [
                _vm.csaData.specificEmissionsValue > 0
                  ? _c("div", { staticClass: "flex-row flex-2 flex-center" }, [
                      _vm._v(
                        _vm._s(_vm.csaData.specificEmissionsValue) +
                          " " +
                          _vm._s(
                            _vm.csaLabels.specificEmissionsMeasureUnitLabel
                          )
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]),
            _c("div", { staticClass: "flex-row flex-1 mb-1" }, [
              _c(
                "div",
                { staticClass: "flex-col flex-1 flex-justify-center label" },
                [
                  _vm._v(
                    _vm._s(_vm.csaLabels.commentSustainabilityLabel) + ": "
                  ),
                ]
              ),
              _c("div", { staticClass: "flex-col flex-3 flex-wrap" }, [
                _vm._v(
                  _vm._s(
                    _vm.co2subscript(_vm.csaData.commentSustainabilityValue)
                  )
                ),
              ]),
            ]),
            _c("div", { staticClass: "flex-row flex-1 mb-1" }, [
              _c(
                "div",
                { staticClass: "flex-col flex-1 flex-justify-center label" },
                [_vm._v(_vm._s(_vm.csaLabels.externalRisksLabel) + ": ")]
              ),
              _c("div", { staticClass: "flex-col flex-3" }, [
                _vm._v(_vm._s(_vm.csaData.externalRisksValue)),
              ]),
            ]),
            _c("div", { staticClass: "flex-row flex-1 mb-1" }, [
              _c(
                "div",
                { staticClass: "flex-col flex-1 flex-justify-center label" },
                [_vm._v(_vm._s(_vm.csaLabels.pmaViewLabel) + ": ")]
              ),
              _c("div", { staticClass: "flex-col flex-3" }, [
                _vm._v(_vm._s(_vm.csaData.pmaViewValue)),
              ]),
            ]),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }